<script>
    export let selected = false;
    const id = Math.round(Math.random() * 99000000 + 1) + "";
</script>

<div class="choice" class:selected>
    <input class="shrink-0" type="checkbox" {id} checked={selected} on:click />
    <div>
        <span>
            <label for={id}>
                <slot name="title" />
            </label>
        </span>
        <p>
            <slot name="description" />
        </p>
    </div>
    <slot />
</div>

<style>
    span {
        font-size: 16px;
        margin-bottom: 0px;
    }
    p {
        margin-bottom: 4px;
    }
    .choice {
        cursor: pointer;
        margin-right: 1rem;
        display: flex;
        flex: 1;
    }
    .choice.selected {
        background: #fafafa;
        border: 1px solid #eee;
    }
    .choice:hover {
        background: #fafafa;
    }
    input[type="checkbox"] {
        width: 20px;
        height: 20px;
    }
</style>
